import { BREAKPOINTS } from "@/settings";
import {
  type ClubImportNudgeId,
  useClubImportNudge as useSharedClubImportNudge,
} from "@repo/shared/redux";
import { useCallback } from "react";
import { useMediaQuery } from "usehooks-ts";

/**
 * Web's binding of the shared nudge trigger. Same contract, except it never
 * fires on a touch device: the nudges are desktop-only for now.
 *
 * Here rather than in the shared hook, so the decision stays web's — the
 * native app is entirely "mobile" and would need its own answer.
 */
export const useClubImportNudge = (nudgeId: ClubImportNudgeId) => {
  const raise = useSharedClubImportNudge(nudgeId);
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  return useCallback(
    (options?: { subsection?: string }) =>
      isTouchDevice ? false : raise(options),
    [isTouchDevice, raise],
  );
};
